import { Box, Stack, Typography, useMediaQuery } from '@mui/material'
import hero from "../../../assets/images/public-ghg-hero.png"
import { FunctionComponent } from 'react'
import gaiaTheme from '../../../root-components/theme';
import { IColorPalatte } from '../shared-services/public-reports.model';
import { usePdfExportMode } from '../../../hooks/use-pdf-export-mode';
import { GAIA_PDF_PAGE_HEIGHT_PX, getGaiaReportSectionShellSx } from './gaia-report-web-page-pdf-styles';
import { ImageDisplay } from '../../../components/presentation-components/display-elements-components/image-display';
import { useReportContentOverride } from '../shared-services/gaia-report-content';

export const GaiaReportWebPageHero: FunctionComponent<{
  reportPeriodName: string,
  colorPalatte: IColorPalatte,
  organisationName: string,
  organisationLogoFilepath?: string,
  coverImageFilepath?: string,
  textColor?: string,
  customTitle?: string,
  customReportPeriodName?: string,
}> = ({ reportPeriodName, colorPalatte, organisationName, organisationLogoFilepath, coverImageFilepath, textColor, customTitle, customReportPeriodName }) => {


  const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const pdfExportMode = usePdfExportMode();
  const backgroundImage = coverImageFilepath || hero;
  const titleMaxWidth = isMobileModeSm ? '100%' : isMobileModeMd ? '75%' : '80%';
  const reportPeriodTitle = customReportPeriodName || reportPeriodName;
  const strapline = useReportContentOverride('cover.strapline');

  return (
    <Stack sx={{
      ...getGaiaReportSectionShellSx({
        backgroundColor: colorPalatte.dark,
        pdfExport: pdfExportMode,
        webBottomPadding: 0,
        webBorderRadius: '0',
        overflow: 'hidden',
      }),
      pt: 0,
      pb: 0,
      pl: 0,
      pr: 0,
    }}>
      <Stack
        sx={{
          minHeight: pdfExportMode ? `${GAIA_PDF_PAGE_HEIGHT_PX}px` : '100vh',
        }}
      >
        <Box
          sx={{
            height: isMobileModeSm ? '56px' : '64px',
            backgroundColor: 'common.white',
            px: isMobileModeSm ? 2 : 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          {organisationLogoFilepath ? (
            <ImageDisplay url={organisationLogoFilepath} alt='Company logo' customHeight={isMobileModeSm ? '32px' : '40px'} customWidth={isMobileModeSm ? '140px' : '180px'} />
          ) : (
            <Box />
          )}
          <Typography
            variant={isMobileModeSm ? 'body1' : 'h6'}
            sx={{ color: 'text.secondary', fontWeight: 600, textAlign: 'right' }}
          >
            {organisationName}
          </Typography>
        </Box>
        <Stack
          sx={{
            flex: 1,
            backgroundColor: colorPalatte.dark,
            p: isMobileModeSm ? 2 : 4,
          }}
        >
          <Stack
            display='flex'
            justifyContent='center'
            sx={{
              flex: 1,
              minHeight: 0,
              borderRadius: isMobileModeSm ? '24px' : '32px',
              overflow: 'hidden',
              px: isMobileModeSm ? 3 : 6,
              backgroundImage: `linear-gradient(90deg, rgba(7, 24, 44, 0.6) 0%, rgba(7, 24, 44, 0.2) 45%, rgba(7, 24, 44, 0.05) 100%), url(${backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            {customTitle ? (
              <>
                <Typography variant={isMobileModeSm ? 'h3' : isMobileModeMd ? 'h2' : 'h1'} sx={{ color: textColor || 'white', fontWeight: 900, maxWidth: titleMaxWidth }}>{customTitle}</Typography>
                <Typography variant={isMobileModeSm ? 'h4' : isMobileModeMd ? 'h3' : 'h2'} sx={{ color: textColor || 'white', mt: 1 }}>{reportPeriodTitle}</Typography>
              </>
            ) : (
              <>
                <Typography variant={isMobileModeSm ? 'h3' : isMobileModeMd ? 'h2' : 'h1'} sx={{ color: textColor || 'white', fontWeight: 900, maxWidth: titleMaxWidth }}>
                  Greenhouse Gas Emissions Report
                </Typography>
                <Typography variant={isMobileModeSm ? 'h4' : isMobileModeMd ? 'h3' : 'h2'} sx={{ color: textColor || 'white', mt: 1 }}>{reportPeriodTitle}</Typography>
              </>
            )}
            {strapline && (
              <Typography sx={{ color: textColor || 'white', mt: 2, fontSize: isMobileModeSm ? '1rem' : '1.25rem', maxWidth: titleMaxWidth, opacity: 0.9 }}>{strapline}</Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}